import { defineMessages } from 'react-intl';

export default defineMessages({
    farmerInsured: {
        id: 'policy.farm.policy-coverage-info.Farmer Insured',
        defaultMessage: 'Farmer Insured'
    }, 
    insuredsAge: {
        id: 'policy.farm.policy-coverage-info.Insureds Age',
        defaultMessage: 'Insureds Age'
    }, 
    address: {
        id: 'policy.farm.policy-coverage-info.Insureds Address',
        defaultMessage: 'Insureds Address'
    }, 
    beneficiary: {
        id: 'policy.farm.policy-coverage-info.Beneficiary',
        defaultMessage: 'Beneficiary'
    }, 
    beneficiarysAge: {
        id: 'policy.farm.policy-coverage-info.Beneficiarys Age',
        defaultMessage: 'Beneficiarys Age'
    },
    beneficiaryAddress: {
        id: 'policy.farm.policy-coverage-info.Beneficiary Address',
        defaultMessage: 'Beneficiary Address'
    },
    hideInsuredsCoverages:{
        id:'policy.farm.policy-coverage-info.Hide Coverages',
        defaultMessage: 'Hide Coverages'
    },
    showInsuredsCoverages:{
        id:'policy.farm.policy-coverage-info.Show Coverages',
        defaultMessage: 'Show Coverages'
    },
    farmersAccident:{
        id:'policy.farm.policy-coverage-info.Farmers Accident',
        defaultMessage: 'Farmers Accident'
    },
    brokerEndorsements:{
        id:'policy.farm.policy-coverage-info.Broker Endorsements',
        defaultMessage: 'Broker Endorsements'
    },
    noBrokerEndorsements:{
        id:'policy.farm.policy-coverage-info.No Broker Endorsements available',
        defaultMessage: 'No Broker Endorsements available'
    },
    farmersAccidentSection:{
        id:'policy.farm.policy-coverage-info.Farmers Accident',
        defaultMessage: 'Farmers Accident'
    },
    noFarmersAccident:{
        id:'policy.farm.policy-coverage-info.No Farmers Accident available',
        defaultMessage: 'No Farmers Accident available'
    },
    
});
